import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { PrismicNextLink } from '@prismicio/next';
import { format } from 'date-fns/format';
import { ArticleBoxProps } from './types';
export const ArticleBox = t0 => {
  const $ = _c(16);
  const {
    title,
    content,
    author,
    publishDate,
    linkToArticle
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h4 className="text-body-5 child:inline mb-3 line-clamp-4 font-bold text-gray-600">{title}</h4>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== content) {
    t2 = <p className="text-body-7 child:inline mb-6 line-clamp-3 text-gray-500">{content}</p>;
    $[2] = content;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== author) {
    t3 = <p className="text-gray-500">{author}</p>;
    $[4] = author;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== publishDate) {
    t4 = publishDate && <><div className="h-2.5 w-[.0625rem] bg-gray-500" /><p className="font-semibold text-gray-600">{format(publishDate, "MMM dd, yyyy")}</p></>;
    $[6] = publishDate;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="text-body-8 flex flex-row items-center gap-2.5">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== linkToArticle || $[12] !== t1 || $[13] !== t2 || $[14] !== t5) {
    t6 = <PrismicNextLink className="flex max-w-90.75 flex-col border-t border-t-gray-300 pt-8 hover:opacity-60" field={linkToArticle} data-sentry-element="PrismicNextLink" data-sentry-component="ArticleBox" data-sentry-source-file="index.tsx">{t1}{t2}{t5}</PrismicNextLink>;
    $[11] = linkToArticle;
    $[12] = t1;
    $[13] = t2;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};